import React from 'react';
import styles from './Home.module.css';
const HomePage = () => {


    return (
        <>
            <h1>
                Mayra Lucero Garcia Ramirez
            </h1>
            <h3>
            Developer
            </h3>


            <h4>Hi thanks for reaching out!</h4>

            <div className={styles.overview}>
                <p>
                    Let me tell you a little bit about myself 👀
                    <br/>
                    I am a proud mexican 🇲🇽, open (and love) to learn about cultures <br/>
                    I lived one year in France (I speak french too) 🇫🇷 <br/>
                    I love movies, music and sports.  <br/>
                    I play football and basketball and I also play a little videogames ⚽️🏀🎮 <br/>
                    <strong> But mostly love programming </strong>
                    <br/>
                    I am always doing things, I love to learn about new techonlogies and start using them.
                    <br/>
                    I studied Computer Engenierring at UASLP (in San Luis Potosí, Mexico) 📚<br/>
                    with a double Degree in Aplied Computing (vía the UASLP-City University of Seattle)🇺🇸 <br/>
                    did a year abroad in Lyon, France (beautiful city) at the École Centrale de Lyon 🖥 <br/>

                    I did my internship at Encora.Inc in 2020
                    <br/>
                    Right now I am working for Nagarro (see info in linkedIn)
                    <br/>
                    <strong>Don't hesitate to contact me as this page is still under construction but the links in the menu work 😊</strong>
                </p>
            
            </div>
            <footer>
                Happy programming!!!!
            </footer>


        </>
    )
}

export default HomePage;

